
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__check_circle-outline",
  "use": "icon__check_circle-outline-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon__check_circle-outline\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M10.242 1.254c-4.821-.137-8.849 3.68-8.986 8.502-.136 4.821 3.68 8.854 8.503 8.99 4.821.132 8.854-3.68 8.99-8.507a8.6 8.6 0 0 0-.42-2.891l-1.11 1.046c.132.583.2 1.188.185 1.814-.116 4.08-3.528 7.303-7.609 7.193-4.08-.116-7.308-3.528-7.198-7.609.116-4.08 3.528-7.308 7.608-7.198a7.364 7.364 0 0 1 3.644 1.094l1.01-.957a8.731 8.731 0 0 0-4.617-1.477zm6.633 2.294-7.5 7.5-2.06-2.055-.44-.445-.884.884.445.44 2.939 2.944 8.384-8.384-.884-.884z\" /><path d=\"M0 0h20v20H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconCheckCircleOutlineIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__check_circle-outline" {...restProps} />
    })
  